import React, { useMemo, useState } from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import ChartLegend from './ChartLegend';
import { CHART_COLORS, getVisibleSeries, toWideSeriesRows } from './chartUtils';

function colorForSeries(seriesKey, index) {
  return CHART_COLORS[index % CHART_COLORS.length];
}

export default function BarChartWidget({ rows, loading }) {
  var [isolatedSeries, setIsolatedSeries] = useState(null);
  var parsed = useMemo(function () {
    return toWideSeriesRows(rows || []);
  }, [rows]);

  var visibleSeries = useMemo(function () {
    return getVisibleSeries(parsed.seriesKeys, isolatedSeries);
  }, [parsed.seriesKeys, isolatedSeries]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!parsed.data.length) {
    return <div className="re-widget-empty">No rows</div>;
  }

  return (
    <div className="re-chart-wrap">
      <ChartLegend
        seriesKeys={parsed.seriesKeys}
        isolatedSeries={isolatedSeries}
        onToggleSeries={function onToggleSeries(seriesKey) {
          setIsolatedSeries(function (previous) {
            return previous === seriesKey ? null : seriesKey;
          });
        }}
        colorForSeries={colorForSeries}
      />

      <ResponsiveContainer width="100%" height={260}>
        <BarChart data={parsed.data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          {visibleSeries.map(function (seriesKey, index) {
            return <Bar key={seriesKey} dataKey={seriesKey} fill={colorForSeries(seriesKey, index)} />;
          })}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
